import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { OptionType } from "@/types/OptionType";
import { IRequest } from "@/interfaces/IRequest";
import { CollectiveAgreementDto } from "@/core/features/collective-agreements/collective-agreement.dto";
import { CreateCollectiveAgreementDto } from "@/core/features/collective-agreements/create-collective-agreement.dto";
import { UpdateCollectiveAgreementDto } from "@/core/features/collective-agreements/update-collective-agreement.dto";
import { HttpRequest } from "@/core/common/http/http-request";
import { plainToInstance } from "class-transformer";
import { applyOptionLoaderPagination } from "@/core/common/presenters/optionLoader";

export class CollectiveAgreementsResource extends ResourceBaseService<
  CollectiveAgreementDto,
  CreateCollectiveAgreementDto,
  UpdateCollectiveAgreementDto
> {
  protected EntityDto = CollectiveAgreementDto;
  protected CreateEntityDto = CreateCollectiveAgreementDto;
  protected UpdateEntityDto = UpdateCollectiveAgreementDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/collective-agreements");
  }

  async optionLoader(inputValue: string, includeArchived = false): Promise<OptionType[]> {
    const request: IRequest = inputValue ? { search: inputValue, searchBy: ["id", "name"] } : {};
    request.sortBy = "name";
    applyOptionLoaderPagination(request);
    const { data } = await this.findAll(request, includeArchived);
    return data.map((value) => value.mapEntityToOptionType([value.name]));
  }

  async archive(id: string): Promise<CollectiveAgreementDto> {
    return this.apiHttpClient
      .request<null, CollectiveAgreementDto>(
        HttpRequest.create({
          url: this.resourceUrl + "/" + id + "/archive",
          method: "PATCH",
          auth: true,
        })
      )
      .then((collectiveAgreement) => plainToInstance(this.EntityDto, collectiveAgreement));
  }

  async unarchive(id: string): Promise<CollectiveAgreementDto> {
    return this.apiHttpClient
      .request<null, CollectiveAgreementDto>(
        HttpRequest.create({
          url: this.resourceUrl + "/" + id + "/unarchive",
          method: "PATCH",
          auth: true,
        })
      )
      .then((collectiveAgreement) => plainToInstance(this.EntityDto, collectiveAgreement));
  }
}
